<template>
  <div class="verify-view">
    <div class="verify-card">
      <div v-if="loading" class="state">
        <div class="emoji">⏳</div>
        <p>Verifierar din e-post…</p>
      </div>
      <div v-else-if="success" class="state">
        <div class="emoji">✅</div>
        <h2>Klart!</h2>
        <p>{{ message }}</p>
        <a href="#/wishlist" class="btn">Till önskelistorna</a>
      </div>
      <div v-else class="state">
        <div class="emoji">⚠️</div>
        <h2>Kunde inte verifiera</h2>
        <p>{{ message }}</p>
        <a href="#/wishlist" class="btn">Tillbaka</a>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/api.js';

export default {
  name: 'VerifyView',
  data() {
    return { loading: true, success: false, message: '' };
  },
  async mounted() {
    const token = this.tokenFromHash();
    if (!token) {
      this.loading = false;
      this.message = 'Ingen verifieringstoken hittades i länken.';
      return;
    }
    try {
      const r = await apiService.verifyEmail(token);
      this.success = true;
      this.message = r.message || 'E-posten är verifierad – du kan nu logga in.';
    } catch (e) {
      this.message = e.message || 'Länken är ogiltig eller har gått ut.';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    tokenFromHash() {
      // Hash: #/verify?token=abc
      const hash = window.location.hash || '';
      const q = hash.indexOf('?');
      if (q === -1) return null;
      return new URLSearchParams(hash.slice(q + 1)).get('token');
    }
  }
};
</script>

<style scoped>
.verify-view {
  min-height: calc(100vh - var(--navbar-height, 70px));
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(900px 450px at 100% -10%, rgba(46, 125, 50, 0.08), transparent 60%),
    #f4f6f8;
  padding: 2rem;
}

.verify-card {
  background: #fff;
  border: 1px solid #e6e9ee;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.12);
  padding: 2.5rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
}

.emoji { font-size: 3rem; margin-bottom: 0.5rem; }

.verify-card h2 {
  margin: 0.25rem 0 0.75rem;
  color: #1f2933;
  font-weight: 800;
}

.verify-card p { color: #6b7684; margin: 0 0 1.5rem; }

.btn {
  display: inline-block;
  background: linear-gradient(135deg, #2e7d32, #1b5e20);
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  padding: 0.7rem 1.4rem;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.28);
}
</style>
